import { render } from "./PassWord.vue?vue&type=template&id=4bab8908&scoped=true"
import script from "./PassWord.vue?vue&type=script&lang=js"
export * from "./PassWord.vue?vue&type=script&lang=js"

import "./PassWord.vue?vue&type=style&index=0&id=4bab8908&scoped=true&lang=css"

import exportComponent from "E:\\Proj\\Apps\\Stock\\vuestock\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bab8908"]])

export default __exports__